<template>
	<div class="home">
		<HeaderGlobal :secondaryHeader="false" :qtSomos="qtSomos" />
		<!-- Page Content Desktop -->
		<div class="container-fluid">
			<div class="container border-left-light pt-2 pb-5">
				<div class="row">
					<div
						class="col-md-6 mx-auto pl-md-1 pr-md-0 pl-md-5 pl-lg-5 pr-lg-0 text-center"
					>
						<div class="text-center">
							<div
								v-if="template.end"
								class="pt-3 text-second-color extra-bold"
							>
								<h4 v-if="template.end[0]" class="text-first-color mb-3">
									<strong>{{ template.end[0] }}</strong>
								</h4>
								<h4 v-if="template.end[1]" class="mb-2">
									{{ template.end[1] }}<br />
									<span v-if="template.end[2]">{{ template.end[2] }}</span>
								</h4>
							</div>

							<div v-if="template.thank.length">
								<h5 class="text-second-color mb-3" :key="template">
									<span v-if="nome != 'undefined'">
										{{ nome }},
										{{
											template.thank[0].toLowerCase() + template.thank.slice(1)
										}}</span
									>
									<span v-else-if="nome == 'undefined' && nomeTwo.length >= 2">
										{{ nomeTwo.trim() }},
										{{
											template.thank[0].toLowerCase() + template.thank.slice(1)
										}}</span
									>
									<span v-else>
										{{
											template.thank[0].toUpperCase() + template.thank.slice(1)
										}}</span
									>
								</h5>
							</div>

							<div v-if="template.fileUploaded && template.fileUploaded.show">
								<img
									:src="findImageUploaded()"
									alt="Arquivo enviado pelo usuário"
									:height="template.fileUploaded.heightImg"
								/>
							</div>
							<h3
								v-if="template.closer"
								class="pt-3 mb-5 text-first-color extra-bold"
							>
								{{ template.closer }}
							</h3>

							<h4 v-if="template.text" class="text-second-color">
								{{ template.text }}
								<br />
								{{ template.secondaryText }}
							</h4>

							<vs-button
								v-if="template.linkMsg"
								:color="surveyBtnColor"
								:text-color="btnTextColor"
								:href="template.linkUrl"
								class="my-3 button-redirect"
							>
								<h5 class="my-0 px-2">{{ template.linkMsg }}</h5>
							</vs-button>

							<!-- Voting choice -->
							<div
								v-if="respostavoto != null"
								class="mb-4 mt-5 text-second-color c-sharing "
							>
								<span>Você votou: </span> <br />
								<h3>
									<img
										v-if="template.iconVoteImg"
										style="width:50px;"
										:src="template.iconVoteImg"
										class="img-fluid img-center"
										alt=""
									/>
									{{ respostavoto }}
								</h3>
							</div>
							<!-- Voting Result Preview -->
							<section
								class="mb-5"
								v-if="template.showSurveyResult && surveyUserId"
							>
								<!-- Result for One Question -->
								<div
									v-if="
										surveyResult.result.length &&
											surveyResult.result.length === 1
									"
								>
									<h5 class="text-first-color">
										Resultado Prévio:
									</h5>
									<div
										v-for="(answer, i) in surveyResult.result[0].answers"
										:key="i"
									>
										<p class="mb-1 pt-3 text-second-color c-sharing">
											{{ answer.answer }}
										</p>
										<div class="progress w-75 mx-auto mb-2">
											<div
												class="progress-bar text-right"
												role="progressbar"
												:style="{
													width: answer.perc + '%',
													backgroundColor: surveyBtnColor,
												}"
												:aria-valuenow="answer.perc"
												aria-valuemin="0"
												aria-valuemax="100"
											></div>
										</div>
										<p class="m-0 mr-1 p-0 text-first-color">
											{{ answer.perc.toFixed(1) + "%" }}
										</p>
									</div>
								</div>
								<!-- Result for more than One Question -->
								<div
									v-if="
										surveyResult.result.length && surveyResult.result.length > 1
									"
								>
									<h5 class="text-first-color">
										Resultados Prévios:
									</h5>
									<div v-for="(result, i) in surveyResult.result" :key="i">
										<p class="mb-1 pt-3 text-second-color c-sharing">
											{{ result.question }}: {{ result.answers[0].answer }}
										</p>
										<div class="progress w-75 mx-auto mb-2">
											<div
												class="progress-bar text-right"
												role="progressbar"
												:style="{
													width: result.answers[0].perc + '%',
													backgroundColor: firstColor,
												}"
												:aria-valuenow="result.answers[0].perc"
												aria-valuemin="0"
												aria-valuemax="100"
											>
												<p
													class="m-0 mr-1 p-0"
													:style="{ color: btnTextColor }"
												>
													{{ result.answers[0].perc + "%" }}
												</p>
											</div>
										</div>
									</div>
								</div>
							</section>

							<!-- Call to action  -->
							<section class="mb-5" v-if="template.ctaText">
								<h5
									v-if="template.ctaText"
									class="mb-4 pt-3 text-second-color c-sharing"
								>
									<strong class="text-first-color">{{
										template.ctaText
									}}</strong>
								</h5>

								<button
									v-if="template.ctaBtnText && template.ctaTokenRecId"
									class="btn btn-home btn-block mt-4 mb-2 btn-validate btn-cta"
									@click="getToken()"
									:style="
										firstColor
											? { backgroundColor: firstColor, color: btnTextColor }
											: ''
									"
								>
									{{ template.ctaBtnText }}
								</button>

								<a v-else-if="template.ctaBtnText" :href="template.ctaUrl">
									<button
										class="btn btn-home btn-block mt-4 mb-4 btn-validate btn-cta"
										:style="
											firstColor
												? { backgroundColor: firstColor, color: btnTextColor }
												: ''
										"
									>
										{{ template.ctaBtnText }}
									</button>
								</a>
							</section>

							<h5 class="mt-3 mb-4 pt-3 text-second-color c-sharing">
								{{ template.sharing[0] }}
								<strong class="text-first-color">{{
									template.sharing[1]
								}}</strong>
								{{ template.sharing[2] }}
							</h5>
							<div v-if="sharingOptions && sharingOptions.length > 0">
								<article v-if="template.sharing" class="mb-3 pt-2">
									<ShareNetwork
										v-for="(option, i) in sharingOptions"
										:key="i"
										:network="option"
										:url="projectURL"
										:title="projectTag"
										:description="fillString(sharingMessage)"
										:quote="fillString(sharingMessage)"
									>
										<img :src="getLogoUrl(option)" class="mx-3" :alt="option" />
									</ShareNetwork>
								</article>
							</div>

							<h5 class="text-second-color">
								{{ template.final }}
							</h5>
							<br />
							<br />
							<h4 class="mb-4 text-second-color">
								<strong>{{ template.hashtag }}</strong>
							</h4>
						</div>
					</div>
				</div>
			</div>
		</div>
		<FooterGlobal :secondaryFooter="false" :qtSomos="qtSomos" />
	</div>
</template>

<script>
import FooterGlobal from "./FooterGlobal";
import HeaderGlobal from "./HeaderGlobal";
import axios from "axios";
const baseDomain = process.env.VUE_APP_BASEDOMAIN;
const baseEnv = process.env.VUE_APP_BASEENV;
const baseUrl = `${baseDomain}/${baseEnv}`;
const connect = process.env.VUE_APP_CONNECTDOMAIN;

export default {
	name: "SurveyFinal",
	data: () => ({
		sharingIcons: [
			{
				name: "facebook",
				url: "static/assets/img/ic-fb-white.png",
				urlBlack: "static/assets/img/ic-fb-black.png",
			},
			{
				name: "whatsapp",
				url: "static/assets/img/ic-wp-white.png",
				urlBlack: "static/assets/img/ic-wp-black.png",
			},
			{
				name: "linkedin",
				url: "static/assets/img/ic-in-white.png",
				urlBlack: "static/assets/img/ic-in-black.png",
			},
			{
				name: "twitter",
				url: "static/assets/img/ic-twitter-white.png",
				urlBlack: "static/assets/img/ic-twitter-black.png",
			},
			{
				name: "instagram",
				url: "static/assets/img/ic-insta-white.png",
				urlBlack: "static/assets/img/ic-insta-black.png",
			},
			{
				name: "telegram",
				url: "static/assets/img/ic-telegram-white.png",
				urlBlack: "static/assets/img/ic-telegram-black.png",
			},
			{
				name: "messenger",
				url: "static/assets/img/ic-messenger-white.png",
				urlBlack: "static/assets/img/ic-messenger-black.png",
			},
		],
		surveyResult: {
			result: [],
		},
	}),
	components: {
		FooterGlobal,
		HeaderGlobal,
	},
	computed: {
		userId() {
			return this.$store.state.userId;
		},

		nomeTwo() {
			return this.$store.state.nomeTwo;
		},

		sharingOptions() {
			if (!this.template.sharingOption) return ["facebook", "whatsapp"];
			else return this.template.sharingOption;
		},

		defaultTextColor() {
			return this.template.style.defaultTextColor
				? this.template.style.defaultTextColor
				: "text-white";
		},

		projectTag() {
			return "#" + this.$store.state.project.projectTag;
		},
		hashtags() {
			return (
				this.$store.state.project.projectTag +
				"," +
				this.$store.state.project.aditionalTags
			);
		},
		company() {
			return this.$store.state.project.entityName;
		},
		sharingMessage() {
			return this.$store.state.project.sharingMessage;
		},
		projectURL() {
			return "https://" + this.$store.state.project.projectURL + "/";
		},
		projectTitle() {
			return this.$store.state.project.projectTitle;
		},
		nick() {
			return this.$store.state.project.nickName;
		},

		nome() {
			var socialName = this.fillString("<@RQ:141@>");
			var n = this.fillString("<@RQ:101@>");
			if (socialName && socialName != "undefined") return socialName;
			return n;
		},

		respostavoto() {
			var voto = this.fillString("<@RQ:" + this.template.questionIdVote + "@>");
			if (voto && voto != "undefined") return voto;
		},

		sobreNome() {
			var n = this.fillString("<@RQ:102@>");
			return n;
		},
		cpf() {
			return this.$store.state.userId;
		},
		surveyUserId() {
			return this.$store.state.surveyUserId;
		},
		template() {
			return this.$store.state.template.finalSurvey;
		},
		surveyBtnColor() {
			return this.$store.state.template.style.surveyBtnColor;
		},
		btnTextColor() {
			return this.$store.state.template.style.btnTextColor;
		},
		qtSomos() {
			return this.$store.state.qtUsers;
		},
	},
	created() {
		if (
			this.template.showSurveyResult ||
			(this.template.fileUploaded && this.template.fileUploaded.show)
		) {
			this.getSurveyResult();
		}
	},
	beforeMount() {
		if (!this.$store.state.template.style) {
			this.$nextTick(() => {
				this.$router.push("home");
			});
		}
	},
	methods: {
		getSurveyResult() {
			let baseurl = baseUrl.replace("https:/", "");
			const url = `https://${baseurl}/SurveyResult/${this.surveyUserId}`;
			axios
				.get(url)
				.then((res) => {
					if (res.data.data.userAnswers) {
						this.surveyResult = res.data.data;
					} else {
						alert(
							"Erro ao recuperar o resultado da votação:\n  " +
								res.data.header.msg
						);
					}
				})
				.catch((err) => {
					alert("Erro ao recuperar o resultado da votação:\n  " + err);
				});
		},
		fillString(s) {
			if (s.includes("<@") && s.includes("@>")) {
				var s1 = s.split("<@");
				var s2 = s1[1].split("@>");
				var s3 = s2[0].split(":");
				var rid = s3[1];
				const value = this.$store.state.answers[rid];
				s = s1[0] + value + s2[1];
			}
			return s;
		},
		getLogoUrl(optionName) {
			let obj = this.sharingIcons.find((el) => {
				return el.name === optionName;
			});
			if (!this.$store.state.template.style.defaultTextColor) return obj.url;
			else return obj.urlBlack;
		},
		getToken() {
			let connectEnv = connect.replace("https:/", "");
			const url = `https://${connectEnv}/${baseEnv}/login2`;
			const payload = {
				id: this.cpf,
				password: "",
				loginType: 1,
				systemId: this.template.ctaTokenSystemId,
				RecId: this.template.ctaTokenRecId,
				ownerId: this.template.ctaTokenownerId,
				subDomainLogin: "",
			};
			axios
				.post(url, payload)
				.then((res) => {
					this.redirectWithToken(res.data.data.access_token);
				})
				.catch((err) => {
					alert(err);
				});
		},
		redirectWithToken(token) {
			window.open(
				`${this.template.ctaUrl}?authToken=${token}&originUserSurveyId=${this.surveyUserId}`,
				"_blank"
			);
		},
		findImageUploaded() {
			return (
				this.surveyResult?.userAnswers?.find(
					(item) => item.quetionId === this.template.fileUploaded.questionId
				)?.answers?.[0]?.answer || null
			);
		},
	},
};
</script>

<style scoped>
.c-sharing {
	font-size: 1.5rem;
	font-weight: 300;
}

a:hover {
	color: var(--first-color);
}

.btn-cta {
	width: 100%;
	max-width: 260px;
	margin: 0 auto;
}

.button-redirect {
	width: 320px;
	height: 60px;
}

.text-redirect {
	font-size: 2rem;
}
</style>
